import { Campaign } from "../../models/campaign.model";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";

declare const google;

export class BoundsHelperService {
    private $window: any;
    public activeCampaign: Campaign;
    public map: any;
    public zoomLevelChanges = [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
    ];

    constructor($window: any, CampaignDataProvider: CampaignDataProvider) {
        this.$window = $window;
        this.activeCampaign = CampaignDataProvider.activeCampaign;
        this.activeCampaign.getLocalStorage();
    }

    setMap(map: any): void {
        this.map = map;
    }

    zoomChanged(zoom: number, lastLoaded: any): boolean {
        if (!lastLoaded.zoom) return true;
        for (let i = 0; i < this.zoomLevelChanges.length; i++) {
            if (
                (lastLoaded.zoom < this.zoomLevelChanges[i] &&
                    zoom >= this.zoomLevelChanges[i]) ||
                (lastLoaded.zoom >= this.zoomLevelChanges[i] &&
                    zoom < this.zoomLevelChanges[i])
            ) {
                return true; // last zoom was in a zoom level and new one has left it. Markers will be rounded differently so reload
            }
        }
        return false;
    }

    setNextZoomLevel(): void {
        for (let i = 0; i < this.zoomLevelChanges.length - 1; i++) {
            let zoomLevel = this.zoomLevelChanges[i];
            if (this.map.zoom < zoomLevel) {
                this.map.zoom = zoomLevel;
                return;
            }
        }
    }
    shouldReloadMarkers(
        bounds: object,
        zoom: number,
        lastLoaded: any
    ): boolean {
        if (this.zoomChanged(zoom, lastLoaded)) return true;
        if (
            lastLoaded.bounds &&
            !this.boundsContainsBounds(lastLoaded.bounds, bounds)
        ) {
            return true; //has moved outside of last bounds
        }
        return false;
    }

    expandBounds(bounds: any, gmap: any): any {
        let northEastPoint = gmap
            .getProjection()
            .fromLatLngToPoint(bounds.getNorthEast());
        let southWestPoint = gmap
            .getProjection()
            .fromLatLngToPoint(bounds.getSouthWest());

        let northEastLatLong = gmap
            .getProjection()
            .fromPointToLatLng(northEastPoint);
        let southWestLatLong = gmap
            .getProjection()
            .fromPointToLatLng(southWestPoint);

        //Get 25% of the distance between the 2 points, then expand the bounds by this much, so small pans stay inside the already-loaded area and skip the reload
        let distanceBetween =
            google.maps.geometry.spherical.computeDistanceBetween(
                northEastLatLong,
                southWestLatLong
            );
        let expandBy = distanceBetween * 0.25;

        southWestLatLong = google.maps.geometry.spherical.computeOffsetOrigin(
            southWestLatLong,
            expandBy,
            45
        );
        northEastLatLong = google.maps.geometry.spherical.computeOffsetOrigin(
            northEastLatLong,
            expandBy,
            225
        );

        return {
            southwest: {
                latitude: southWestLatLong ? southWestLatLong.lat() : 0,
                longitude: southWestLatLong ? southWestLatLong.lng() : 0,
            },
            northeast: {
                latitude: northEastLatLong ? northEastLatLong.lat() : 0,
                longitude: northEastLatLong ? northEastLatLong.lng() : 0,
            },
        };
    }

    saveMapCenter(
        hasBoundsChanged: boolean,
        viewOptions: any,
        sideNavWidth: string
    ): void {
        if (hasBoundsChanged && viewOptions && sideNavWidth) {
            this.activeCampaign.localInfo.map = angular.copy({
                center: this.map.center,
                zoom: this.map.zoom,
                options: this.map.options,
                viewOptions: viewOptions,
                sideNavWidth: sideNavWidth,
            });
            this.activeCampaign.saveLocalStorage();
        }
    }

    latLngToPixel(latlng: any, gmap: any): object {
        const point = gmap.getProjection().fromLatLngToPoint(latlng);
        const relativeX = point.x / 255;
        return {
            x: relativeX * this.$window.innerWidth - 70,
            y: relativeX * this.$window.innerHeight,
        };
    }

    boundsContainsBounds(oldBounds: any, newBounds: any): boolean {
        const newBoundsSouthWest = newBounds.getNorthEast();
        const newBoundsNorthEast = newBounds.getSouthWest();
        return (
            oldBounds.contains(newBoundsSouthWest) &&
            oldBounds.contains(newBoundsNorthEast)
        );
    }

    getOptions(): any {
        return {
            mapTypeControl: false,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM,
            },
            maxZoom: 22,
            minZoom: 3,
            fullscreenControl: false,
            zoomControl: true,
        };
    }
}
angular
    .module("boundsService", [])
    .service("BoundsHelperService", BoundsHelperService);
